/**
 * Created by PhpStorm.
 * User: i.sollima
 * Contact: i.sollima@accenture.com
 * Date: 06/02/2020
 * Time: 12:41
 */

(function () {
  const $targets = {
    brands: '.brand-list-container .brand--carousel',
    cars: '#home-card-list',
  };

  analyze();
  inject();

  function analyze() {
    const $nodeMatch = document.querySelector('#model-page');
    if ($nodeMatch) {
      const carID = $nodeMatch.getAttribute('data-model-id');
      const brandID = $nodeMatch.getAttribute('data-brand-id');
      if (carID && brandID) {
        const date = new Date().getTime();
        const lastViewedData = localStorage.getItem('lastViewed');
        let arrCar = (lastViewedData && JSON.parse(lastViewedData)) || null;
        if (arrCar && !arrCar.length) {
          arrCar = [arrCar];
        } else if (!arrCar) {
          arrCar = [];
        }
        let isInArray = false;
        for (let i = 0; i < arrCar.length; i++) {
          if (carID === arrCar[i].carID && brandID === arrCar[i].brandID) {
            isInArray = true;
            arrCar[i].date = date;
            break;
          }
        }
        if (!isInArray) {
          let maxRC = drupalSettings.maxRelatedCars
            ? parseInt(drupalSettings.maxRelatedCars)
            : 8;
          while (arrCar.length >= maxRC) {
            arrCar.pop();
          }
          arrCar.push({
            carID,
            brandID,
            date,
          });
        }
        arrCar = arrCar.sort((a, b) => {
          if (a.date < b.date) {
            return 1;
          } else if (a.date > b.date) {
            return -1;
          } else {
            return 0;
          }
        });
        try {
          localStorage.setItem('lastViewed', JSON.stringify(arrCar));
        } catch (e) {
          console.error(e);
        }
      }
    }
  }

  function generateCarHP(res) {
    const hpCardList = document.querySelector('#home-card-list');
    const filterHP = hpCardList.querySelector('.filters-result-container');
    filterHP.classList.add('card-list');
    res.forEach((item) => {
      const $cloneCard = hpCardList
        .querySelector('.card-to-clone')
        .cloneNode(true);
      $cloneCard.classList.remove('card-to-clone');
      //set link for navigation on click
      const $link = $cloneCard.querySelector('a');

      if (item.externalUrl && item.url) {
        $link.removeAttribute('href');
        $link.classList.add('external-link');
        $link.setAttribute(
          'onclick',
          "trackBanner('" + item.url + "', '" + item.mobileUrl + "', true)",
        );
        /*$link.setAttribute("data-script-url",item.scriptUrl)
          $link.setAttribute("data-no-script-url",item.noScriptUrl)*/
      } else {
        item.url
          ? $link.setAttribute('href', item.url)
          : $link.setAttribute('href', '#');
      }

      //set image
      const $image = $cloneCard.querySelector('.card--offer--image-container');
      $image && item.image && $image.querySelector('img')
        ? $image.querySelector('img').setAttribute('src', item.image)
        : $image.querySelector('img')
        ? ($image.querySelector('img').style.display = 'none')
        : null;
      //set brand
      const $brand = $cloneCard.querySelector('.card--offer--content--brand');
      $brand.innerHTML =
        item.brandName.toLowerCase() === 'cupra' ||
        item.brandName.toLowerCase() === 'seat'
          ? item.brandName.toUpperCase()
          : item.brandName;
      //set model
      const $model = $cloneCard.querySelector('.card--offer--content--model');
      $model.innerHTML = item.title;
      //set price
      //if new field is true, ignore price
      const $price = $cloneCard.querySelector('.full-price');
      if (!item.hidePrice) {
        if (item.showCustomPrice && item.customPrice) {
          $cloneCard.querySelector(
            '.card--offer--content--subtitle',
          ).innerHTML = '<p>' + item.customPrice + '</p>';
        } else {
          const formatter = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
          });
          $price.innerHTML = formatter.format(+item.price);
        }
      } else {
        $cloneCard.querySelector('.card--offer--content--subtitle').remove();
      }
      //set button
      const $cta = $cloneCard.querySelector('.cta-add-to-compare-card');
      $cta.setAttribute('data-model-name', item.title);
      $cta.setAttribute('data-variation-id', item.variationId);
      $cta.setAttribute('data-variation-full-name', item.variationFullName);
      $cta.setAttribute('data-variation-name', item.variationName);
      $cta.setAttribute('data-variation-brand', item.brandName);
      if (item.externalUrl && item.url) {
        $cta.classList.add('external-link');
        $cta.setAttribute(
          'onclick',
          "trackBanner('" + item.url + "', '" + item.mobileUrl + "')",
        );
        /* 
          $link.setAttribute("data-script-url",item.scriptUrl)
          $link.setAttribute("data-no-script-url",item.noScriptUrl)
          */
        $cta.classList.remove('cta-add-to-compare-card');
      }

      const offers = window.offers_data || [];
      const id = item.id || '';
      //set badge
      const $offer = $cloneCard.querySelector('.card--badge--last-news');
      if (offers.includes(id)) {
        $offer.classList.remove('hidden');
        $price.classList.add('strikethrough');
      } else {
        $offer.classList.add('hidden');
        $price.classList.remove('strikethrough');
      }

      if (item.editorialBadge) {
        const $editorialBadge = $cloneCard.querySelector(
          '.card--badge--most-visited',
        );
        $editorialBadge.innerHTML = item.editorialBadge;
        $editorialBadge.classList.remove('hidden');
      }
      filterHP.appendChild($cloneCard);
      $cloneCard.classList.remove('hidden');
    });
  }

  function inject() {
    const lastViewedData = localStorage.getItem('lastViewed');
    let arrCar = (lastViewedData && JSON.parse(lastViewedData)) || null;
    if (arrCar && !arrCar.length) {
      arrCar = [arrCar];
    } else if (!arrCar) {
      arrCar = [];
    }
    const { brandID } = arrCar.length ? arrCar[0] : { brandID: null };
    const $brands = document.querySelector($targets.brands);
    const $cars = document.querySelector($targets.cars);

    if (brandID && $brands) {
      const $brand = $brands.querySelector(`[data-brand-id='${brandID}']`);
      if ($brand) {
        const $li = $brand.parentElement;
        const $container = $li.parentElement;
        $container.insertBefore($li, $container.firstChild);
      }
    }
    if ($cars) {
      //change here
      $cars.querySelector('.loader').classList.add('active');
      callApi({
        uri: '/api/home_page/related_cars',
        method: 'POST',
        data: arrCar,
      }).then((json) => {
        if (json.data && json.data.length > 0) {
          generateCarHP(json.data);
        }
        $cars.querySelector('.loader').classList.remove('active');
        /* Wire interactivity */
        if (typeof addToCompareCard !== 'undefined') {
          addToCompareCard();
          if (
            typeof disableButtonAddToCompare !== 'undefined' &&
            document.querySelectorAll(
              '.cta-add-to-compare-card.already-compare',
            ).length === 2
          ) {
            disableButtonAddToCompare();
          }
        }
        if (typeof homeCardListInit !== 'undefined') {
          homeCardListInit(true);
        }
      });
    }
  }
})();
